// templates
import tauronTemplate from './assets/recipient-template-tauron.xlsx';
import diplomaTemplate from './assets/recipient-template-diploma.xlsx';
import mvpTemplate from './assets/recipient-template-mvp.xlsx';
import openPlatformTemplate from './assets/recipient-template-open-platform.xlsx';

import { CUSTOMER } from '../../constraints';

export const getCustomerProperties = (customer) => {
  switch (customer) {
    case CUSTOMER.DIPLOMA:
      return {
        dragDropMessageId: 'Drag and drop here student list',
        templateFileName: 'Szablon listy odbiorców - dyplomy.xlsx',
        templateHref: diplomaTemplate,
      };
    case CUSTOMER.TAURON:
      return {
        dragDropMessageId: 'Drag and drop here recipient list',
        templateFileName: 'Szablon listy odbiorców.xlsx',
        templateHref: tauronTemplate,
      };
    case CUSTOMER.OPEN_PLATFORM:
      return {
        dragDropMessageId: 'Drag and drop here recipient list',
        templateFileName: 'Recipient list template.xlsx',
        templateHref: openPlatformTemplate,
      };
    default:
      return {
        dragDropMessageId: 'Drag and drop here recipient list',
        templateFileName: 'Szablon listy odbiorców - mvp.xlsx',
        templateHref: mvpTemplate,
      };
  }
};
